if ( typeof QuickAddToCart !== 'function' ) {

	class QuickAddToCart extends HTMLElement {
		
		constructor(){
			super();
			if ( this.querySelector('product-form') ) {
				this.init();
			}
		}

		init(){
			this.querySelector('product-form').addEventListener('add-to-cart', ()=>{
				if ( ! document.body.classList.contains('template-cart') ) {
					document.getElementById('site-cart-sidebar').show();
					if ( KROWN.settings.cart_action == 'overlay') {
						document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
							elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
						});
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
					};
				}
			});
		}
	}

  if ( typeof customElements.get('quick-add-to-cart') == 'undefined' ) {
		customElements.define('quick-add-to-cart', QuickAddToCart);
	}

}

if ( typeof QuickViewProduct !== 'function' ) {

	class QuickViewProduct extends HTMLElement {

		constructor(){
			super();
		}

		connectedCallback(){
			if ( this.querySelector('a') ) this.init();
			else queueMicrotask(() => { if (this.isConnected) this.init(); });
		
		}

		initModalProduct(){

			if ( this.quickViewModal.querySelector('[data-js-product-form]') ) {
				this.quickViewModal.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
					document.getElementById('site-cart-sidebar')?.show();
					document.getElementById('site-cart-sidebar')?.scrollTo({top: 0, behavior: 'smooth'});
					this.quickViewModal.hide();
				});
			}

			if ( Shopify && Shopify.PaymentButton ) {
				setTimeout(()=>{
					Shopify.PaymentButton.init();
				}, 50);
			}

			KROWN.functions.eventDispatcher('krown:product-modal:init', {
				productId: this.quickViewModal.querySelector('product-page')?.dataset.productId || null,
				variant: this.quickViewModal.querySelector('product-page [data-js-variant-data]') ? JSON.parse(this.quickViewModal.querySelector('product-page [data-js-variant-data]').textContent) : null
			});

		}

		init(){

      const link = this.querySelector('a');
      if (!link || this._fbQuickLink === link) return;
      this._fbQuickLink = link;
			this.quickViewModal = null;
			this.querySelector('a').addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.RETURN ) {
					window.lastFocusedElm = this.querySelector('a');
				}
			})
			this.querySelector('a').addEventListener('click', e=>{

				e.preventDefault();

				if ( ! this.quickViewModal ) {

					const target = e.currentTarget;
					target.classList.add('kt-working');

					fetch(`${target.getAttribute('href')}${ target.getAttribute('href').includes('?') ? '&' : '?' }view=quick-view`)
						.then(response => response.text())
						.then(text => {

							const quickViewHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('#product-quick-view');

							// create modal w content

							const quickViewContainer = document.createElement('div');
							quickViewContainer.innerHTML = `<modal-box id="modal-${target.dataset.id}"	
								class="kt-modal kt-modal--product" 
								data-options='{
									"enabled": false,
									"showOnce": false,
									"blockTabNavigation": true
								}'
								tabindex="-1" role="dialog" aria-modal="true" 
							>
								<div class="kt-container--large" style="position: relative;max-width: min(1200px, var(--theme-max-width));">
									<div class="kt-modal-content" data-js-product-page style="background: transparent;"><div class="kt-modal-content__inner" style="padding: 0;"></div></div>
								</div>
								<span class="kt-modal-background" data-js-close></span>
							</modal-box>`;

							this.quickViewModal = quickViewContainer.querySelector('modal-box');
							document.body.appendChild(this.quickViewModal);
							this.quickViewModal.querySelector('.kt-modal-content__inner').innerHTML = `${quickViewHTML.innerHTML}`;

							// Move any nested modals (e.g. tax/shipping policy) to body so they stack on top of Quick View
							const quickViewContent = this.quickViewModal.querySelector('.kt-modal-content__inner');
							if (quickViewContent) {
								quickViewContent.querySelectorAll('modal-box').forEach(nestedModal => {
									document.body.appendChild(nestedModal);
								});
							}

							const closeButton = document.createElement('button');
							closeButton.classList.add('kt-modal-close');
							closeButton.setAttribute('data-js-close', '');
							closeButton.setAttribute('style', 'position:absolute;margin:0;top:-15px;right:calc(var(--gutter-container) - 15px)');
							closeButton.innerHTML = `<span class="kt-visually-hidden">${window.KROWN.settings.locales.close_popup}</span>${window.KROWN.settings.symbols.close}`;
							closeButton.addEventListener('click', ()=>{
								this.quickViewModal.hide();
							});
							this.quickViewModal.querySelector('.kt-container--large').append(closeButton);

							setTimeout(()=>{
								this.initModalProduct();
							}, 100);

							if ( ! window.productPageScripts ) {
								const scripts = this.quickViewModal.querySelectorAll('script[src]');
								scripts.forEach(elm=>{
									const script = document.createElement('script');
									script.src = elm.src;
									script.async = false;
									document.body.append(script);
									window.productPageScripts = true;
								});
							}

							setTimeout(()=>{
								this.quickViewModal.show();
								KROWN.functions.eventDispatcher('krown:product-modal:show', {
									modalElement: this.quickViewModal
								});
								target.classList.remove('kt-working');
							}, 250);
							
						});

				} else {
					this.quickViewModal.show();
					KROWN.functions.eventDispatcher('krown:product-modal:show', {
						modalElement: this.quickViewModal
					});
				}

				setTimeout(()=>{
					if ( document.getElementById('site-search-sidebar') && document.getElementById('site-search-sidebar').classList.contains('kt-sidebar--opened') ) {
						document.getElementById('site-search-sidebar').hide();
					}
				}, 500);

			})
		}
	}

  if ( typeof customElements.get('quick-view-product') == 'undefined' ) {
		customElements.define('quick-view-product', QuickViewProduct);
	}

}
